import { render, staticRenderFns } from "./Cola.vue?vue&type=template&id=00764862&scoped=true"
import script from "./Cola.vue?vue&type=script&lang=js"
export * from "./Cola.vue?vue&type=script&lang=js"
import style0 from "./Cola.vue?vue&type=style&index=0&id=00764862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00764862",
  null
  
)

export default component.exports